export function filterTree(nodes, searchTerm) {
    if (!searchTerm || !nodes) return nodes;

    return nodes.reduce((filtered, node) => {
        const nodeClone = { ...node };
        const filteredChildren = filterTree(node?.children || [], searchTerm);

        const searchLower = searchTerm.toLowerCase();
        const nameMatches = node.name.toLowerCase().includes(searchLower);
        const teamMatches = node.teams?.some(team =>
            team.name.toLowerCase().includes(searchLower)
        ) || false;

        if (nameMatches || teamMatches || filteredChildren.length > 0) {
            nodeClone.children = filteredChildren;
            filtered.push(nodeClone);
        }

        return filtered;
    }, []);
}